import { h } from '@stencil/core';
import type { ConversationalSearchMessages } from '../../conversational-search-types/conversational-search-types.type';
import { ConversationalSearchDynamicBannerZeroResult } from './variants/zero-result';
import type { WidgetConversationalSearchDynamicBanner } from './dynamic-banner';
import { ConversationalSearchDynamicBannerLoadingResult } from './variants/loading-result';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';
import { ConversationalSearchDynamicBannerAnimatedTag } from './parts/animated-tag';

export const renderVariant = (
  data: ConversationalSearchMessages,
  context: WidgetConversationalSearchDynamicBanner,
) => {
    if (context.isProcessing) {
      return <ConversationalSearchDynamicBannerLoadingResult />;
    } else if (data?.results?.length) {
      const results = data.results;

      return (
        <uiaas-search-widget-conversational-search-dynamic-banner-data-result
          query={context.query}
          labelProvider={(e, f) => context.labelProvider(e, f)}
          data={results}
          conversationalSearchBrandUrl={context.conversationalSearchBrandUrl}
          conversationalSearchMedaliaFormId={context.conversationalSearchMedaliaFormId}
          country={context.country}
          language={context.language}
        />
      );
    } else {
      return (
        <ConversationalSearchDynamicBannerZeroResult
          text={selectZeroResultVariant((e, f) => context.labelProvider(e, f), data)}
        />
      );
    }
};

export const renderHeaderTag = (
  isProcessing: boolean,
  labelProvider: labelProviderInterface,
  isInitialView: boolean,
  isMobileView : boolean
) => {
    if (!isProcessing)
      return (
        <qds-tag
          color="green"
          status="success"
          importance={isInitialView ? 'emphasized' : void 0}
          size={isMobileView ? 'small' : 'standard'}
          text={labelProvider(
            'conversational.search.banner.dynamic.tag',
            'AI insights',
          )}
          icon-name="sparkles"
        />
      );

    return <ConversationalSearchDynamicBannerAnimatedTag />;
};

export const selectZeroResultVariant = (
  labelProvider: labelProviderInterface,
  data: ConversationalSearchMessages
) => {
    const connectionErrorInformation = labelProvider(
      'conversational.search.banner.dynamic.error.result',
      'I’m sorry, but I encountered an issue while processing your request. As an AI assistant, I\'m unable to provide the information you need at the moment. Please try again later or check the search results below for more information.'
    );

    const noResultInformation = labelProvider(
      'conversational.search.banner.dynamic.zero.result',
      'I’m sorry, but I cannot provide AI information related to your query. As an AI assistant I am currently focusing on Schneider Electric products only.',
    );

    return data?.isErrorResponse ? connectionErrorInformation : noResultInformation;
};
